// @core/api/endpoints/secret/update_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SecretPolicyResponse,
  UpdatePolicyRequest,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Update access policy
 * Updates an access policy's rules. Changes take effect immediately for all actors using this policy.
 */
export async function UpdatePolicy(
  policy_name: string,
  data: UpdatePolicyRequest,
  options?: RequestOptions
): Promise<SecretPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/policies/:policy_name`;
  requestPath = requestPath.replace(':policy_name', encodeURIComponent(policy_name));
  const requestOptions = options;
  return client.patch<SecretPolicyResponse>(requestPath, data, requestOptions);
}
